import React, { useEffect, useState } from "react"
import "../styles/login.css"
import { useAuthUser } from "../context/authuser"
import { Link, useNavigate } from "react-router-dom";
import "../styles/loadhelper.css"
import { toast } from "react-toastify";

function Register() {
  const { SignUp, liveUser, load, loading } = useAuthUser();
  const router = useNavigate()
  const [user, setUser] = useState({
    displayName: "",
    email: "",
    password: ""
  })

  function handleChange(e) {
    const { name, value } = e.target
    setUser({
      ...user,
      [name]: value

    })

  }
  useEffect(() => {
    if (liveUser) {
      return router("/home")
    }
  }, [liveUser, router])

  async function Submit(e) {
    e.preventDefault();

    try {
      if (user.displayName !== '' && user.email !== '' && user.password !== '') {
        if (user.password.length >= 6) {
          await SignUp(user.displayName, user.email, user.password)
          setUser({
            displayName: "",
            email: "",
            password: ""
          })
          router("/home")
          return;
        }
        toast.error("Password length min 6 letters")

      } else {
        toast.error("Input field required")
      }
    } catch (err) {
      toast.error("Try again")
      console.log(err)
    }
  }



  return (
    <div className="login">
      {load && <div className="spin"></div>}
      {!load && !liveUser && (
        <div className="login-bg">

          <form onSubmit={Submit}>
            <h3 className="register">Register</h3>
            <div className="user-data">
              <input className="name"
                required
                type="text"
                placeholder="Name"
                value={user.name}
                name="displayName"
                onChange={handleChange}

              /><br />
              <input className="name"
                required
                type="text"
                placeholder="E-mail"
                value={user.email}
                name="email"
                onChange={handleChange}

              /><br />
              <input className="name"
                required
                type="password"
                placeholder="password"
                name="password"
                value={user.password}
                onChange={handleChange}
              />
              <button disabled={loading} onClick={Submit} className="login-btn">{loading ? "loding..." : "Sign Up"}</button>
              <p className="sign">Already have account <Link to="/login" className="sign"> Login ?</Link></p>
            </div>
          </form>
        </div>
      )}


    </div>
  )
}

export default Register;